export default "__VITE_ASSET__40371624__"